<blaze-table-popup-menu class="find-record-panel" (closePanel)="closePanel.emit()">
  <ng-container title>Find an Existing Record</ng-container>

  <ng-container content>
    <div class="searchbox">
      <input
        #filterInput
        [formControl]="searchFormCtrl"
        autocomplete="off"
        name="search-input"
        placeholder="Search existing value"
        class="p-12 rounded search-input"
        type="text"
        data-cy="FilterInput:input"
        (click)="preventEventAction($event)"
      />
    </div>

    <div class="records mt-16" (scroll)="scrollBottom($event)">
      @if (records().length) {
        @for (record of records(); track record.value) {
          @let recordSelected = isRecordSelected(record);
          @if (!recordSelected) {
            <div
              (click)="!recordSelected ? selectRecord(record) : null"
              [class.selected]="recordSelected"
              class="records-content column"
            >
              @let isRecordValueVisible = !record?.tableHasExpandableLinks;
              @let recordValue = getRecordDisplayValue(record);
              <div class="record">
                @if (isRecordValueVisible) {
                  <div class="record-value truncate" [blazeTooltip]="recordValue">{{
                    recordValue
                  }}</div>
                }
                <div class="record-display" [class.fulldisplay]="!isRecordValueVisible">
                  <div
                    class="font-medium"
                    [blazeTooltip]="getRecordDisplayValue(record) || record.displayValue"
                  >
                    <span class="text-accent mr-3">*</span
                    >{{
                      getRecordDisplayValue(record) ||
                        record.displayValue ||
                        getRecordLinkedValue(record.value) ||
                        ''
                    }}
                  </div>
                  @if (record?.otherLinkedValues?.length) {
                    <div class="flex gap-40">
                      @for (
                        linkedValues of record?.otherLinkedValues?.slice(0, 3);
                        track linkedValues
                      ) {
                        <div class="flex flex-col">
                          <div class="record-display-column">{{ linkedValues?.[0] }}</div>
                          <div class="record-display-value truncate">{{
                            getRecordDisplayValue(linkedValues?.[1]) ||
                              getRecordLinkedValue(linkedValues?.[1])
                          }}</div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }
      }

      @if (nextPageToken) {
        <div class="p-14">
          <blaze-loading-indicator />
        </div>
      }

      @if (rows.length && records().length === 0) {
        <div class="message"> Linked column has no valid data </div>
      }

      @if (!rows.length && !records().length) {
        <blaze-loading-indicator class="message" />
      } @else if (!records().length) {
        <div class="message"> No records found </div>
      }
    </div>
  </ng-container>
</blaze-table-popup-menu>
